import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronRight, ExternalLink } from 'lucide-react';

export default function CollapsibleSection({
  title,
  count,
  summary,
  viewAllLink,
  defaultExpanded = false,
  icon: Icon,
  children,
}) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className="bg-white dark:bg-neutral-800 rounded-lg border border-neutral-200 dark:border-neutral-700 overflow-hidden">
      {/* Header */}
      <div
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-neutral-50 dark:hover:bg-neutral-700/50"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-3">
          <button
            className="p-1 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700"
            onClick={(e) => {
              e.stopPropagation();
              setIsExpanded(!isExpanded);
            }}
          >
            {isExpanded ? (
              <ChevronDown className="w-5 h-5 text-neutral-400" />
            ) : (
              <ChevronRight className="w-5 h-5 text-neutral-400" />
            )}
          </button>
          {Icon && <Icon className="w-5 h-5 text-neutral-500 dark:text-neutral-400" />}
          <h3 className="font-medium text-neutral-900 dark:text-white">{title}</h3>
          {count !== undefined && (
            <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-neutral-100 text-neutral-600 dark:bg-neutral-700 dark:text-neutral-300">
              {count}
            </span>
          )}
        </div>
        <div className="flex items-center gap-4">
          {!isExpanded && summary && (
            <span className="text-sm text-neutral-500 dark:text-neutral-400">{summary}</span>
          )}
          {viewAllLink && (
            <Link
              to={viewAllLink}
              onClick={(e) => e.stopPropagation()}
              className="text-sm text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 flex items-center gap-1"
            >
              View All <ExternalLink className="w-3 h-3" />
            </Link>
          )}
        </div>
      </div>

      {/* Content */}
      {isExpanded && (
        <div className="border-t border-neutral-200 dark:border-neutral-700 p-4">{children}</div>
      )}
    </div>
  );
}
